var {AmpersandState, AmpersandCollection} = require('catalog/libs');
var FilterCollection = require('./hpe.productlist.filter.model');

/**
 * filter group model
 * model hierarchy: filterlist > facet > filtergroup (this) > filter
 */
var FilterGroupModel = AmpersandState.extend({

    props: {
        facet_id: 'string', //eslint-disable-line camelcase
        facetLabel: 'string', //eslint-disable-line camelcase
        expanded: ['boolean', false, true] //default to true
    },

    derived: {

        domid: {
            deps: ['facet_id'],
            fn: function() {
                return 'group_' + this.facet_id;
            }
        },

        //return count of selected filters in this group
        selectedFilterCount: {
            deps: ['filters'],
            fn: function() {
                if (this.facetValues.length) {
                    return this.facetValues.reduce(function(count, filter) {
                        return (filter.isChecked) ? count + 1 : count;
                    }, 0);
                } else {
                    return 0;
                }
            }
        },

        //return boolean: if any filters in this group are selected
        hasActiveFilter: {
            deps: ['selectedFilterCount'],
            fn: function() {
                return (this.selectedFilterCount > 0);
            }
        }
    },

    collections: {
        facetValues: FilterCollection //eslint-disable-line camelcase
    }
});

/**
 * collection of filter group models
 */
var FilerGroupCollection = AmpersandCollection.extend({
    model: FilterGroupModel
});

module.exports = FilerGroupCollection;
